import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TrailerFormView } from './trailer-form-view';
import {
	getLegalsSelector,
	getIsLegalsLoadingSelector,
	getTrailerTypesSelector,
	getIsAdminSelector,
	getIsTrailerInfoLoadingSelector,
	getIsTrailerTypesLoadingSelector,
	getIsModesLoadingSelector,
	getIsTypeDateIssueVisibleSelector,
	getModesSelector,
	getOwnershipsSelector,
	getIsOwnershipsLoadingSelector,
	getIsOwnershipVisibleSelector,
} from '../../selectors';

export const TrailerFormWrapper = ({
	isTrailerInfoLoading,
	ownerships,
	isOwnershipsLoading,
	legals,
	isLegalsLoading,
	trailerTypes,
	isTypeDateIssueVisible,
	modes,
	isAdmin,
	isTrailerTypesLoading,
	isModesLoading,
	isOwnershipVisible,
}) => {
	return (
		<TrailerFormView
			isTrailerInfoLoading={isTrailerInfoLoading}
			ownerships={ownerships}
			isOwnershipsLoading={isOwnershipsLoading}
			legals={legals}
			isLegalsLoading={isLegalsLoading}
			trailerTypes={trailerTypes}
			isTypeDateIssueVisible={isTypeDateIssueVisible}
			modes={modes}
			isAdmin={isAdmin}
			isTrailerTypesLoading={isTrailerTypesLoading}
			isModesLoading={isModesLoading}
			isOwnershipVisible={isOwnershipVisible}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isTrailerInfoLoading: getIsTrailerInfoLoadingSelector(),
	ownerships: getOwnershipsSelector(),
	isOwnershipsLoading: getIsOwnershipsLoadingSelector(),
	legals: getLegalsSelector(),
	isLegalsLoading: getIsLegalsLoadingSelector(),
	trailerTypes: getTrailerTypesSelector(),
	isTypeDateIssueVisible: getIsTypeDateIssueVisibleSelector(),
	modes: getModesSelector(),
	isAdmin: getIsAdminSelector(),
	isTrailerTypesLoading: getIsTrailerTypesLoadingSelector(),
	isModesLoading: getIsModesLoadingSelector(),
	isOwnershipVisible: getIsOwnershipVisibleSelector(),
});

TrailerFormWrapper.propTypes = {
	isTrailerInfoLoading: PropTypes.bool.isRequired,
	isOwnershipsLoading: PropTypes.bool.isRequired,
	ownerships: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	legals: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isLegalsLoading: PropTypes.bool.isRequired,
	trailerTypes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isTypeDateIssueVisible: PropTypes.bool.isRequired,
	modes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAdmin: PropTypes.bool.isRequired,
	isTrailerTypesLoading: PropTypes.bool.isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	isOwnershipVisible: PropTypes.bool.isRequired,
};

const TrailerForm = connect(mapStateToProps)(TrailerFormWrapper);

export { TrailerForm };
